import React from "react"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { useTranslation } from "react-i18next"
import InsuranceTable from "./InsuranceTable"

export default function InsuranceList() {
  const { t } = useTranslation()

  return (
    <div className="page-content">
      <div className="container-fluid">
        <Breadcrumbs title="" breadcrumbItem={t("Insurance")} />
        <InsuranceTable />
      </div>
    </div>
  )
}
